import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { updateSummaryInfo } from './cancelSubscription';
import { translate } from '../../../i18n/I18nProvider';
import Optional from '../../../utils/optional';
import moment from 'moment';

const changeSubscription = async ({
  clientId,
  subscription,
  isMultiedit,
  selectedRows,
  setIsLoading,
  newProduct,
  clientName
}) => {
  setIsLoading(true);

  if (!isMultiedit) {
    let summaryInfo = {};
    const { name, translations } = subscription;
    const mappedData = mapDataToUpdate({
      newProduct,
      subscription,
      clientName,
      clientId
    });

    try {
      const response = await postData({
        url: URLS.PRODUCT_ORDERS,
        passErrors: true,
        data: {
          ...mappedData
        }
      });
      if (response?.status === RESPONSE_CODES.CREATED) {
        summaryInfo = updateSummaryInfo({
          summaryInfo,
          name,
          fromChange: true,
          changeInfo: {
            from: Optional(translations?.sku?.default).or(''),
            to: Optional(newProduct?.name).or('')
          },
          newElement: {
            isError: false
          }
        });
      }
    } catch (e) {
      summaryInfo = updateSummaryInfo({
        summaryInfo,
        name,
        fromChange: true,
        changeInfo: {
          from: Optional(translations?.sku?.default).or(''),
          to: Optional(newProduct?.name).or('')
        },
        newElement: {
          text: translate('MESSAGE.CHANGE_SUBS_ERROR', {
            name
          }),
          isError: true,
          errors: Optional(e.response?.data?.errors).or([])
        }
      });
    } finally {
      setIsLoading(false);
      return { requestCompleted: true, summaryInfo };
    }
  } else {
    let summaryInfo = {};

    for (const row of selectedRows) {
      const { name: elName, translations } = row;
      const mappedData = mapDataToUpdate({
        newProduct,
        subscription: row,
        clientName,
        clientId
      });

      if (newProduct.value === row.sku) {
        summaryInfo = updateSummaryInfo({
          summaryInfo,
          name: elName,
          fromChange: true,
          changeInfo: {
            from: Optional(translations?.sku?.default).or(''),
            to: Optional(newProduct?.name).or('')
          },
          newElement: {
            text: 'Same product - no change',
            isError: false
          }
        });
      } else {
        try {
          const response = await postData({
            url: URLS.PRODUCT_ORDERS,
            passErrors: true,
            data: {
              ...mappedData
            }
          });

          if (response?.status === RESPONSE_CODES.CREATED) {
            summaryInfo = updateSummaryInfo({
              summaryInfo,
              name: elName,
              fromChange: true,
              changeInfo: {
                from: Optional(translations?.sku?.default).or(''),
                to: Optional(newProduct?.name).or('')
              },
              newElement: {
                isError: false
              }
            });
          }
        } catch (e) {
          summaryInfo = updateSummaryInfo({
            summaryInfo,
            name: elName,
            fromChange: true,
            changeInfo: {
              from: Optional(translations?.sku?.default).or(''),
              to: Optional(newProduct?.name).or('')
            },
            newElement: {
              text: translate('MESSAGE.CHANGE_SUBS_ERROR', {
                elName
              }),
              isError: true,
              errors: Optional(e.response?.data?.errors).or([])
            }
          });
        }
      }
    }

    setIsLoading(false);
    return { requestCompleted: true, summaryInfo };
  }
};

export default changeSubscription;

const mapDataToUpdate = ({
  newProduct,
  subscription,
  clientId,
  clientName
}) => {
  const {
    accountReference,
    externalReference,
    name: subscriptionName
  } = subscription;
  const { sku, name: newProductName, prices } = newProduct;

  const foundedPrice = prices.find(price => price.sku === sku) || {};

  const mappedDate = moment()
    .add(1, 'months')
    .format('YYYY-MM');

  return {
    order_items: [
      {
        action: 'migrate',
        identifier: 'SUBSCRIPTION',
        account_reference: accountReference,
        date_of_change: `${mappedDate}-01`,
        product: {
          id: externalReference,
          name: subscriptionName,
          referred_type: 'Subscription'
        },
        product_offering: {
          new_sku: sku,
          name: newProductName
        },
        product_price: {
          currency: foundedPrice.currency || 'DKK',
          setup: {
            price: foundedPrice.setupPrice || '0'
          },
          recurring: {
            price: foundedPrice.price || '0',
            period: 'MONTH'
          }
        }
      }
    ],
    related_party: {
      id: clientId,
      name: clientName
    }
  };
};
